import { render } from "./Terms.vue?vue&type=template&id=5b87551d&scoped=true&ts=true"
import script from "./Terms.vue?vue&type=script&lang=ts"
export * from "./Terms.vue?vue&type=script&lang=ts"

import "./Terms.vue?vue&type=style&index=0&id=5b87551d&lang=sass&scoped=true"

import exportComponent from "/home/casedrive/releases/front/108/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b87551d"]])

export default __exports__